import { render, staticRenderFns } from "./AppError.vue?vue&type=template&id=ab1db9a8&scoped=true&"
import script from "./AppError.vue?vue&type=script&lang=ts&"
export * from "./AppError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1db9a8",
  null
  
)

export default component.exports